export function setPayer(payload) {
  return {
    type: '@payer/SET_PAYER',
    payload,
  };
}
